import { FC, useCallback, useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import EditModal from 'components/UI/EditModal';
import Button from 'components/UI/Button';
import { Content, ButtonGrid, DesiredItemValue, DesiredItem } from './styled';
import { FieldValues, SubmitHandler, useForm } from 'react-hook-form';
import { DesiredValue } from 'models';
import { Paragraph } from 'components/UI/IconLabel/styled';

type Props = {
  desiredValues: DesiredValue[];
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

const DesiredConfirmation: FC<Props> = ({
  desiredValues,
  open,
  onClose,
  onConfirm,
}) => {
  const { handleSubmit } = useForm();

  // Submit
  const onSubmit: SubmitHandler<FieldValues> = useCallback(
    () => {
      if (desiredValues) {
        onClose();
        onConfirm();
      }
    },
    [desiredValues, onClose, onConfirm]
  );

  const content = useMemo(() => {
    if (desiredValues === undefined) {
      return;
    }
    return desiredValues.map((item, index) => {
      return (
        <DesiredItem key={`${item.resourceId}-${index}`}>
          {item.resourceId}
          <DesiredItemValue>{item.value}</DesiredItemValue>
        </DesiredItem>
      );
    });
  }, [desiredValues]);

  return (
    <EditModal title="device_desired_values.title" open={open} close={onClose}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Paragraph>
          <FormattedMessage id="connectivity.desired_values.confirmation_message" />
        </Paragraph>
        <Content>{content}</Content>
        <ButtonGrid>
          <Button
            onClick={onClose}
            backgroundColor="transparent"
            color="primary"
          >
            <FormattedMessage id="device_desired_values.btn_cancel" />
          </Button>
          <Button submit id="confirm_desired_btn">
            <FormattedMessage id="device_desired_values.btn_confirm" />
          </Button>
        </ButtonGrid>
      </form>
    </EditModal>
  );
};

export default DesiredConfirmation;
